import React from 'react';

import style from './EditMyInfoComponents.module.scss';

export const Header = (props: { title: string | JSX.Element }) => {
  return <header className={style.header}>{props.title}</header>;
};
